import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("title", null, "icon-hint", -1),
    _createElementVNode("g", { "fill-rule": "nonzero" }, [
      _createElementVNode("path", { d: "M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16zm0 1A9 9 0 1 1 9 0a9 9 0 0 1 0 18z" }),
      _createElementVNode("path", { d: "M7.001 6.886h2.736v6.767H11V15H7.016v-1.348h1.199v-5.42H7l.001-1.346zm.93-2.875a.92.92 0 0 1 .086-.388 1.04 1.04 0 0 1 .227-.321A1.095 1.095 0 0 1 8.993 3c.14 0 .274.028.4.082a1.073 1.073 0 0 1 .56.541.965.965 0 0 1 0 .787 1.147 1.147 0 0 1-.227.334 1.021 1.021 0 0 1-.733.31 1.056 1.056 0 0 1-.75-.31 1.165 1.165 0 0 1-.226-.333.965.965 0 0 1-.085-.4z" })
    ], -1)
  ]))]))
}
export default { render: render }